import axios from 'axios'
import { getRouteForContext } from '~/services/apiService'

export async function getStreamingLink ({ programId = '', flatId = '', token = '' }) {
  const link = await axios.get(getRouteForContext('streaming', [programId, flatId, token]))

  return { link: link.data.link }
}
